import { Action } from '@ngrx/store';
import {
  LicenseSettingListFilterActions,
  LicenseSettingListFilterActionTypes
} from '../actions/license-setting-list-filter.actions';


export interface State {
  UsingStatusOptions: number;
  LicenseTypeOptions: number;
}

export const initialState: State = {
  UsingStatusOptions: -1,
  LicenseTypeOptions: -1
};

export function reducer(state = initialState, action: LicenseSettingListFilterActions): State {
  switch (action.type) {
    case LicenseSettingListFilterActionTypes.SelectLicenseSettingListFilters:
      return {...state,
      UsingStatusOptions: action.payload.UsingStatus,
      LicenseTypeOptions: action.payload.LicenseType};

    default:
      return state;
  }
}
